import { ENV_KEYS, getEnvValue } from "./shared/helpers/envHelper";

export default {
  cognito: {
    userPoolId: getEnvValue(ENV_KEYS.CognitoUserPoolId),
    clientId: getEnvValue(ENV_KEYS.CognitoClientId),
    region: getEnvValue(ENV_KEYS.CognitoRegion),
    domain: getEnvValue(ENV_KEYS.CognitoDomain),
    oktaOidcProvider: getEnvValue(ENV_KEYS.OktaOidcProvider),
    redirectUri: `${window.location.origin}/login/callback`,
    logoutUri: `${window.location.origin}/login`,
    responseType: "code",
    scope: ["openid", "profile", "email"],
    hostedUI: {
      responseType: "code",
      scope: ["openid", "profile", "email"],
      identityProvider: undefined,
      customState: undefined,
    },
  },
};